// extracted by mini-css-extract-plugin
export var chip = "_a2-0";
export var filterDropdown = "_a2-5";
export var filterItem = "_a2-6";
export var icon = "_a2-1";
export var removeButton = "_a2-3";
export var removeIcon = "_a2-4";
export var separator = "_a2-2";